<template>
  <span
    class="animated-value"
    :aria-label="value"
    data-test="animated-value"
  >{{ displayed }}</span>
</template>

<script>
import { parseFormattedNumber, formatLike } from '@/utils/animated-value';
import { tweenNumber } from '@/utils/motion';
import mixinMotion from '@/mixin/mixin-motion';

/** Mostra um valor já formatado e, quando ele muda, passa pelos números até o novo. Termina sempre no texto exato. */
export default {
  name: 'AnimatedValue',

  mixins: [mixinMotion],

  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    /* Na entrada da tela o número sobe desde zero */
    countOnMount: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return { displayed: String(this.value ?? '') };
  },

  watch: {
    value(next, previous) {
      this.animateBetween(parseFormattedNumber(previous)?.number ?? 0);
    }
  },

  mounted() {
    if (this.countOnMount) this.animateBetween(0);
  },

  methods: {
    animateBetween(from) {
      const finalText = String(this.value ?? '');
      const target = parseFormattedNumber(finalText);

      if (!target) {
        this.displayed = finalText;

        return;
      }

      this.trackMotion(
        tweenNumber({
          from,
          to: target.number,
          onUpdate: (number) => {
            this.displayed = formatLike(target, number);
          },
          onComplete: () => {
            this.displayed = finalText;
          }
        })
      );
    }
  }
};
</script>

<style scoped>
.animated-value {
  font-variant-numeric: tabular-nums;
}
</style>
